import React from "react";
import Accordion from "react-bootstrap/Accordion";
import editIcon from "../../assets/images/accorditionediticon.svg";
import "./Accordion.styles.css";
import { dateConversion } from "../../utils/formatDate";

interface Props {
  carData: any;
  projectCarData: any;
}

const gradeColors: { [key: string]: string } = {
  "Major": "#C43131",
  "Minor": "#F49632",
  Observation: "#919191",
};

const CARAccordion: React.FC<Props> = ({ carData, projectCarData }) => {
  console.log(projectCarData)

  return (
    <>
      <Accordion defaultActiveKey={['0', '1', '2']} alwaysOpen>
        <Accordion.Item eventKey="0" className="cardetailsaccordion">
          <Accordion.Header>
            <img src={editIcon} alt="edit" /> CAR Detail
          </Accordion.Header>
          <Accordion.Body>
            <>
              <div className="row">
                <div className="col-4">
                  <table className="accordion-table table table-borderless">
                    <tbody>
                      <tr>
                        <td style={{ fontWeight: 800 }}>Certificate</td>
                        <td>
                          {
                            projectCarData?.certificateId || "--"
                          }
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 800 }}>Finding</td>
                        <td>{carData?.correctiveActionRequest?.Name || "--"}</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 800 }}>Status</td>
                        <td>{carData?.correctiveActionRequest?.Status__c || "--"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-4">
                  <table className="accordion-table table table-borderless">
                    <tbody>
                      <tr>
                        <td style={{ fontWeight: 800 }}>Grade</td>
                        <td>
                          <span className="td-grade" style={{color:gradeColors[carData?.correctiveActionRequest?.Grade__c]}}>
                            {carData?.correctiveActionRequest?.Grade__c}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 800 }}>
                          Primary Standard Reference:
                        </td>
                        <td>
                          {
                            carData?.correctiveActionRequest
                              ?.Primary_Standard_Reference__r?.Name || "--"
                          }
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 800 }}>
                          Other applicable references:
                        </td>
                        <td>
                          {carData?.correctiveActionRequest?.Other_Reference__c || "--"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-4">
                  <table className="accordion-table table table-borderless">
                    <tbody>
                      <tr>
                        <td style={{ fontWeight: 800 }}>Issue Date</td>
                        <td>
                          {carData?.correctiveActionRequest?.Identified_Date__c ? dateConversion(carData?.correctiveActionRequest?.Identified_Date__c, "DD MMMM YYYY") : "--"}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 800 }}>Due date</td>
                        <td>{carData?.correctiveActionRequest?.Due_Date__c ? dateConversion(carData?.correctiveActionRequest?.Due_Date__c, "DD MMMM YYYY") : "--"}</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: 800 }}>
                          Closed Date (if applicable)
                        </td>
                        <td>
                          {carData?.correctiveActionRequest?.Closed_Date__c ? dateConversion(carData?.correctiveActionRequest?.Closed_Date__c, "DD MMMM YYYY") : "--"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          </Accordion.Body>
        </Accordion.Item>
        <br />
        <Accordion.Item eventKey="1" className="cardetailsaccordion">
          <Accordion.Header>
            {" "}
            <img src={editIcon} alt="edit" /> Description of Nonconformance or
            Observation
          </Accordion.Header>
          <Accordion.Body>
            {carData?.correctiveActionRequest
              ?.Observation_Description_of_Nonconforma__c ? (
              <p className="m-3">
                {carData?.correctiveActionRequest?.Observation_Description_of_Nonconforma__c}
              </p>
            ) : (
              <p className="m-3" style={{ textAlign: "center", fontWeight: "bold" }}>No Data Availble.</p>
            )}
          </Accordion.Body>
        </Accordion.Item>
        <br />
        <Accordion.Item eventKey="2" className="cardetailsaccordion">
          <Accordion.Header>
            {" "}
            <img src={editIcon} alt="edit" /> Evidence of Nonconformance
          </Accordion.Header>
          <Accordion.Body>
            {carData?.correctiveActionRequest?.Non_Conformance_Evidence__c ? (
              <p className="m-3">
              {carData?.correctiveActionRequest?.Non_Conformance_Evidence__c}
            </p>
            ) : (
              <p className="m-3" style={{ textAlign: "center", fontWeight: "bold" }}>No Data Availble.</p>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default CARAccordion;
